import { FunctionComponent, PropsWithChildren } from "react";

export const Modal: FunctionComponent<PropsWithChildren> = ({ children }) => {
  return (
    <div className="bg-[#000] fixed inset-0 z-50 flex items-center justify-center bg-opacity-50">
      <div className="rounded-xl bg-white p-4 shadow-2xl">{children}</div>
    </div>
  );
};
